import AbstractIntegration from "./AbstractIntegration.js";

/**
 * `XledgerIntegration` is an implementation of `AbstractIntegration`
 * for integration with Xledger.
 */
export default class XledgerIntegration extends AbstractIntegration {
	getName() {
		return "Xledger";
	}

	routeName() {
		return "Xledger";
	}

	isXledgerIntegration() {
		return true;
	}

	canHaveLinkedDocuments() {
		return true;
	}

	static getType() {
		return "XledgerIntegration";
	}
}
